import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '@app/services/api/api.service';
import { FollowService } from '@app/services/api/follow.service';
import { FlashService } from '@app/services/flash.service';
import {
  Create,
  CreateFail,
  CreateSuccess,
  Load,
  LoadFail,
  LoadMe,
  LoadMeSuccess,
  LoadSuccess,
  MemberActionTypes,
  Remove,
  RemoveFail,
  RemoveSuccess,
  Update,
  UpdateFail,
  UpdateSuccess
} from '@core/actions/member.actions';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

@Injectable()
export class MemberEffects {
  @Effect()
  load$: Observable<Action> = this.actions$.pipe(
    ofType<Load>(MemberActionTypes.Load),
    map(action => action.id),
    switchMap(id => {
      return this.followsApi.getFollowMembers(id).pipe(
        map(
          members =>
            new LoadSuccess(
              members.map(m => {
                return { ...m, FollowId: id };
              })
            )
        ),
        catchError(error => of(new LoadFail(error)))
      );
    })
  );

  @Effect()
  loadMe$: Observable<Action> = this.actions$.pipe(
    ofType<LoadMe>(MemberActionTypes.LoadMe),
    map(action => action.UserId),
    switchMap(id => {
      return this.followsApi.getFollowMembersByUser(id).pipe(
        map(
          (members: []) => new LoadMeSuccess(members)
        ),
        catchError(error => of(new LoadFail(error)))
      );
    })
  );

  @Effect()
  create$: Observable<Action> = this.actions$.pipe(
    ofType<Create>(MemberActionTypes.Create),
    map(action => [action.FollowId, action.UserId]),
    switchMap(([FollowId, UserId]) => {
      return this.followsApi.addFollowMembers(FollowId, UserId).pipe(
        map(member => new CreateSuccess({ ...member, FollowId })),
        catchError(error => of(new CreateFail(error)))
      );
    })
  );

  @Effect({ dispatch: false})
  createSuccess$: Observable<Action> = this.actions$.pipe(
    ofType<CreateSuccess>(MemberActionTypes.CreateSuccess),
    // map(action => action),
    tap(res => {
      this.fs.emit({ type: 'success', message: 'Usuario/a agregado/a' });
      // return new AddOne(action.alarm);
    })
  );

  @Effect()
  update$: Observable<Action> = this.actions$.pipe(
    ofType<Update>(MemberActionTypes.Update),
    map(action => action.data),
    switchMap(data => {
      const { FollowId, ...changes } = data;
      return this.followsApi.updateFollowMember(FollowId, changes).pipe(
        map(member => new UpdateSuccess({ ...member, FollowId })),
        catchError(error => of(new UpdateFail(error)))
      );
    })
  );

  @Effect()
  remove$: Observable<Action> = this.actions$.pipe(
    ofType<Remove>(MemberActionTypes.Remove),
    map(action => [action.FollowId, action.UserId]),
    switchMap(([FollowId, UserId]) => {
      return this.followsApi.removeFollowMembers(FollowId, UserId).pipe(
        map(member => new RemoveSuccess(UserId)),
        catchError(error => of(new RemoveFail(error)))
      );
    })
  );

  constructor(
    private actions$: Actions,
    private api: ApiService,
    private followsApi: FollowService,
    private fs: FlashService,
    private router: Router
  ) { }
}
